/**
 * @preserve
 * Copyright 2015-2016 Igor Bezkrovnyi
 * All rights reserved. (MIT Licensed)
 *
 * iq.ts - Image Quantization Library
 */
import { IPaletteQuantizer } from "./common"
import { NeuQuant } from "./neuquant/neuquant"
import { NeuQuantFloat } from "./neuquant/neuquantFloat"
import { RGBQuant } from "./rgbquant/rgbquant"
import { ColorHistogram } from "./rgbquant/colorHistogram"
import { WuQuant, WuColorCube } from "./wu/wuQuant"

export {
    IPaletteQuantizer,

    NeuQuant,
    NeuQuantFloat,
    RGBQuant,
    WuQuant,

    ColorHistogram,
    WuColorCube
}



/** WEBPACK FOOTER **
 ** ./src/palette/index.ts
 **/